<template>
  <div class="stats-pie-container">
    <div class="stat-details">
      <div class="stat-item">
        <div class="stat-number">{{ stats.thisYearMaintenance }}</div>
        <div class="stat-desc">今年触发事件数量</div>
      </div>
      <div class="stat-item">
        <div class="stat-number">{{ stats.lastYearMaintenance }}</div>
        <div class="stat-desc">上年触发事件数量</div>
      </div>
      <div class="stat-item">
        <div class="stat-number">{{ stats.totalEvents }}</div>
        <div class="stat-desc">总触发事件数量</div>
      </div>
    </div>
    <div class="pie-chart-container">
      <slot name="pie-chart"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TriggerEventsStats",
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        thisYearMaintenance: 0,
        lastYearMaintenance: 0,
        totalEvents: 0
      })
    }
  }
}
</script>

<style scoped lang="less">
.stats-pie-container {
  display: flex;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  height: 220px;
  position: relative;
  overflow: hidden;
}

.stats-pie-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.stat-details {
  width: 120px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stat-item {
  margin-bottom: 8px;
  padding: 8px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.1), rgba(0, 136, 204, 0.1));
  border-radius: 8px;
  border-left: 3px solid #00d4ff;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-item:last-child {
  margin-bottom: 0;
}

.stat-number {
  font-size: 22px;
  font-weight: bold;
  color: #00d4ff;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  line-height: 1;
}

.stat-desc {
  font-size: 11px;
  color: #88c4ff;
  margin-top: 3px;
  line-height: 1.2;
}

.pie-chart-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
